import { render, staticRenderFns } from "./GroupParamMobileElement.vue?vue&type=template&id=70b6691a&scoped=true&"
import script from "./GroupParamMobileElement.vue?vue&type=script&lang=js&"
export * from "./GroupParamMobileElement.vue?vue&type=script&lang=js&"
import style0 from "./GroupParamMobileElement.vue?vue&type=style&index=0&id=70b6691a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b6691a",
  null
  
)

export default component.exports